<div [ngClass]="{ 'layer-info-child': filterActive }"
  class="layer-information-panel-block d-flex justify-content-between">
  <div class="viewer-left-panel">
    <div class="left-panel-logo d-flex">
      <img class="left-panel-logo-img" src="assets\images\logo.svg" alt="{{ 'Header.logo' | translate }}"
        title="{{ 'Header.logo' | translate }}" />
      <img class="left-panel-yellow-img" src="assets\images\sn-small-logo.svg" alt="{{ 'Header.logo' | translate }}"
        title="{{ 'Header.logo' | translate }}" />
    </div>
    <div class="links d-flex">
      <a routerLink="/activecase" routerLinkActive="active">
        {{ "Header.activeCase" | translate }}
      </a>
      <hr class="verticalLine" [ngClass]="{ verticalLineRev: reviewerFlag }" />
      <a routerLink="/casehistory" routerLinkActive="active" *ngIf="managerFlag">
        {{ "Header.caseHistory" | translate }}
      </a>
      <a routerLink="/mycases" routerLinkActive="active" *ngIf="reviewerFlag">
        {{ "Header.myCases" | translate }}
      </a>
    </div>
  </div>
  <!-- delete Filter items -->
  <div class="ml-list" #filterContainer>
    <div class="button-wrapper">
      <span *ngIf="selectedanatomy">
        <button [ngClass]="{ 'list-btn_lastChild': anatomyGradient == false }" class="btn list-btn font-weight-450"
          *ngFor="let anatomy of selectedanatomy">
          {{ anatomy.anatomyName | titlecase }}
          <span (click)="deleteFilter(anatomy, 'anatomy')" class="icon-cross">X</span>
        </button>
      </span>
      <span *ngIf="selectedtype">
        <button [ngClass]="{ 'list-btn_lastChild': typeGradient == false }" class="btn list-btn font-weight-450"
          *ngFor="let type of selectedtype">
          {{ type.type }}
          <span (click)="deleteFilter(type, 'type')" class="icon-cross">X</span>
        </button>
      </span>
      <span *ngIf="selectedassigned">
        <button [ngClass]="{ 'list-btn_lastChild': assignedGradient == false }"
          class="btn list-btn fonassignedt-weight-450" *ngFor="let assigned of selectedassigned">
          {{ assigned.assignedName }}
          <span (click)="deleteFilter(assigned, 'assigned')" class="icon-cross">X</span>
        </button>
      </span>
      <span *ngIf="selectedstatus">
        <button [ngClass]="{ 'list-btn_lastChild': statusGradient == false }" class="btn list-btn font-weight-450"
          *ngFor="let status of selectedstatus">
          {{ status.status | titlecase }}
          <span (click)="deleteFilter(status, 'status')" class="icon-cross">X</span>
        </button>
      </span>
      <span *ngIf="selectedimagecenter">
        <button [ngClass]="{ 'list-btn_lastChild': imagecenterGradient == false }" class="btn list-btn font-weight-450"
          *ngFor="let imagecenter of selectedimagecenter">
          {{ imagecenter.imagecenterName }}
          <span (click)="deleteFilter(imagecenter, 'imagecenter')" class="icon-cross">X</span>
        </button>
      </span>
      <span *ngIf="selectedComplDateStart && selectedComplDateEnd">
        <button [ngClass]="{ 'list-btn_lastChild': completeddateGradient == false }" class="btn list-btn font-weight-450">
          {{ selectedComplDateStart | date: "MM/dd/yyyy" }} -
          {{ selectedComplDateEnd | date: "MM/dd/yyyy" }}
          <span (click)="deleteFilter(null, 'startDate')" class="icon-cross">X</span>
        </button>
      </span>
      <span *ngIf="!selectedComplDateStart && selectedComplDateEnd">
        <button [ngClass]="{ 'list-btn_lastChild': completeddateGradient == false }" class="btn list-btn font-weight-450">
          {{ "Header.endingComp" | translate }}
          {{ selectedComplDateEnd | date: "MM/dd/yyyy" }}
          <span (click)="deleteFilter(null, 'endDate')" class="icon-cross">X</span>
        </button>
      </span>
      <span *ngIf="selectedDueDateStart && selectedDueDateEnd">
        <button [ngClass]="{ 'list-btn_lastChild': duedateGradient == false }" class="btn list-btn font-weight-450">
          {{ selectedDueDateStart | date: "MM/dd/yyyy" }} -
          {{ selectedDueDateEnd | date: "MM/dd/yyyy" }}
          <span (click)="deleteFilter(null, 'startDateDue')" class="icon-cross">X</span>
        </button>
      </span>
      <span *ngIf="!selectedDueDateStart && selectedDueDateEnd">
        <button [ngClass]="{ 'list-btn_lastChild': duedateGradient == false }" class="btn list-btn font-weight-450">
          {{ "Header.endingDue" | translate }}
          {{ selectedDueDateEnd | date: "MM/dd/yyyy" }}
          <span (click)="deleteFilter(null, 'endDateDue')" class="icon-cross">X</span>
        </button>
      </span>
    </div>
    <div class="custom-ellipsis" *ngIf="isOverflowing">...</div>
  </div>
  <div class="right-panel">
    <div class="information-panel">
      <span *ngIf="infoFlag" class="notifaction d-flex" [ngClass]="[ isInfoChecked ? 'selected' : '',
          infoFlag ? 'activeNot' : '' ]">
        <img id="notifaction" src="assets\images\notification.svg" alt="{{ 'Header.notification' | translate }}"
          title="{{ 'Header.notification' | translate }}" (click)="searchNewRecord()" />
      </span>
      <span *ngIf="errInfoFlag || errFlag" class="Errorinfoicon d-flex" [ngClass]="[ isErrorChecked ? 'selected' : '',
          infoFlag != true ? 'caseinfoFlag' : '', errFlag ? 'myCaseErr' : '' ]">
        <img id="Errorinfoicon" src="assets\images\bx_error-alt.svg" alt="{{ 'Header.error' | translate }}"
          title="{{ 'Header.error' | translate }}" (click)="searchRejectedRecord()" />
      </span>
      <span *ngIf="greenFlag" class="flag d-flex greenFlag" [ngClass]="{ selected: isGreenFlagChecked }">
        <img src="assets\images\flag.svg" alt="{{ 'Header.greenflag' | translate }}"
          title="{{ 'Header.greenflag' | translate }}" (click)="searchReviewRec()" />
      </span>
      <span *ngIf="redFlag" class="flag d-flex redFlag" [ngClass]="{ selected: isRedFlagChecked }">
        <img src="assets\images\redflag.svg" alt="{{ 'Header.redflag' | translate }}"
          title="{{ 'Header.redflag' | translate }}" (click)="searchOverDueRec()" />
      </span>
      <span *ngIf="timeFlag || errFlag" class="time d-flex" [ngClass]="{ selected: isDayFlagChecked }">
        <img id="time_img" src="assets\images\24 Hrs1.svg" alt="{{ 'Header.time' | translate }}"
          title="{{ 'Header.time' | translate }}" (click)="searchonDayUntilDueRec()" /></span>
      <!-- Filter button -->
      <span *ngIf="filterFlag" class="filter d-flex" [ngClass]="{ selected: filterActive }">
        <img id="filter_img" src="..\assets\images\filter.svg" alt="{{ 'Header.filter' | translate }}"
          title="{{ 'Header.filter' | translate }}" (click)="openFilter()" />
        <div class="filter_name" (click)="openFilter()" title="{{ 'Header.filter' | translate }}">
          {{ "Header.filter" | translate }}
        </div>
      </span>
      <span *ngIf="searchFlag" class="search d-flex" title="{{ 'Header.searchIcon' | translate }}">
        <div class="search_input" (click)="focusOnSearchInput()">
          <img id="searchIcon_img" src="assets\images\searchIcon.svg" alt="{{ 'Header.searchIcon' | translate }}"
            title="{{ 'Header.searchIcon' | translate }}" />
          <input #searchInp type="text" class="search" placeholder="Search" [(ngModel)]="searchText" (keyup.enter)="enterClicks()"/>
        </div>
        <button class="font-SN-core btn-1" (click)="searchRecord()">
          {{ "Header.Search" | translate }}
        </button>
      </span>
    </div>
    <div class="actions-tools">
      <span class="mng d-flex">
        <div class="text_name">
          <p class="profile-ellipsis" title="{{loggedinUserName | titlecase}}">{{ loggedinUserName }}</p> 
          <img *ngIf="imageurl" id="manage-user" class="img" src="{{ imageurl }}" alt="{{ loggedinUserName | titlecase }}"
            title="{{ loggedinUserName | titlecase }}" />
          <img *ngIf="!imageurl" id="manage-user"  src ="..\assets\images\no-profile-image.png" alt="{{ loggedinUserName | titlecase }}"
          title="{{ loggedinUserName | titlecase }}" />
        </div>
      </span>
      <span class="settings d-flex">
        <img id="settings_img" src="..\assets\images\settings.svg" routerLink="/settings" routerLinkActive="active"
          *ngIf="managerFlag" alt="{{ 'Header.settings' | translate }}"
          title="{{ 'Header.settings' | translate }}" /></span>
      <span class="exit d-flex">
        <img id="exit_img" src="..\assets\images\exit.svg" alt="{{ 'Header.exit' | translate }}"
        (click)="exitToApp()" title="{{ 'Header.exit' | translate }}" />
      </span>
      <span class="logout d-flex">
        <img id="logout_img" src="..\assets\images\logout.svg" alt="{{ 'Header.logout' | translate }}"
          (click)="userLogout()" title="{{ 'Header.logout' | translate }}" />
      </span>
    </div>
  </div>
</div>